

export class widgetStatistics {

  static sendPresentationStatisticsEvent(tabName, isVisible) {
      const label = [
        'tab:' + tabName,
        'visible:' + isVisible
      ].join('###');

      return this.__track('show', label);
  }

  static sendUserRedirectionStatisticsEvent( tabName: string, clickType: string, linkType: string, position?: number, openUrl?: string) {
      const label = [
        'linkType:' + linkType, //searchResult, seeAll
        'tab:' + tabName,
        'clickType:' + clickType, //right, left, keyboard
        position ? 'position:' + position : '',
        openUrl ? 'openUrl:' + openUrl : ''
      ].join('###');

      return this.__track('click', label);
  }

  private static __track(action, label) {
      return {
        category: 'widget-exchange-community-support',
        action: action,
        label: label
      };
  }
}
